import { getCalculatePercentileAction, getEditApplicationAction } from './shared';
import type { CreateApplicationStageConfig } from './types';

export const createWithdrawnStageConfig: CreateApplicationStageConfig = actions => ({
  badge: { id: 'withdrawn', label: 'Withdrawn', color: 'error' },
  getAttributes: () => [],
  getActions: () => [getEditApplicationAction(actions), getCalculatePercentileAction(actions)],
  getActiveProcessesProps: () => ({
    collapsible: false,
    items: [
      {
        id: 'close-application',
        title: 'Close application',
        description: 'The candidate has withdrawn, add the details to the timeline and close the application',
        action: {
          id: 'close-application',
          label: 'Close application',
          variant: 'contained',
          onClick: actions.closeApplication,
        },
      },
    ],
  }),
});
